import { render, staticRenderFns } from "./SideSwitchFilter.vue?vue&type=template&id=d4eac74c&scoped=true&"
import script from "./SideSwitchFilter.vue?vue&type=script&lang=js&"
export * from "./SideSwitchFilter.vue?vue&type=script&lang=js&"
import style0 from "./SideSwitchFilter.vue?vue&type=style&index=0&id=d4eac74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4eac74c",
  null
  
)

/* custom blocks */
import block0 from "./SideSwitchFilter.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports